import React, { useState, useEffect } from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import axios from 'axios';
import { ChevronRight } from 'lucide-react';
import { API, BACKEND_URL } from '@/constants/data';

export const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { axios.get(`${API}/blog?published_only=true`).then(r => { setPosts(r.data); setLoaded(true); }).catch(() => setLoaded(true)); }, []);
  if (loaded && posts.length === 0) return <Navigate to="/" replace />;
  return (
    <div className="pt-20 min-h-screen bg-white" data-testid="blog-page">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <h1 className="font-heading text-5xl text-[#0A2463] uppercase mb-12 text-center">Blog</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map(post => (
            <article key={post.id} className="bg-[#F8FAFC] rounded-2xl overflow-hidden border border-slate-200 hover:-translate-y-1 transition-transform" data-testid={`blog-card-${post.slug}`}>
              {post.image_url && <img src={post.image_url.startsWith('/') ? `${BACKEND_URL}${post.image_url}` : post.image_url} alt={post.title} className="w-full aspect-video object-cover" />}
              <div className="p-6">
                <p className="text-[#00A8E8] text-xs font-body font-bold mb-2">{new Date(post.created_at).toLocaleDateString('pt-BR')}</p>
                <h2 className="font-heading text-2xl text-[#0A2463] uppercase mb-2">{post.title}</h2>
                <p className="text-[#475569] text-sm font-body line-clamp-2">{post.excerpt}</p>
                <Link to={`/blog/${post.slug}`} className="text-[#00A8E8] text-sm mt-4 inline-flex items-center gap-1 font-bold font-body">
                  Ler mais <ChevronRight size={14} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export const BlogPostPage = () => {
  const [post, setPost] = useState(null);
  const location = useLocation();
  const slug = location.pathname.split('/').pop();
  useEffect(() => { axios.get(`${API}/blog/${slug}`).then(r => setPost(r.data)).catch(console.error); }, [slug]);
  if (!post) return <div className="pt-20 min-h-screen bg-white flex items-center justify-center text-[#0A2463] font-body">Carregando...</div>;
  return (
    <div className="pt-20 min-h-screen bg-white" data-testid="blog-post-page">
      <article className="max-w-4xl mx-auto px-6 lg:px-8 py-16">
        <Link to="/blog" className="text-[#00A8E8] mb-8 inline-flex items-center gap-1 font-body font-bold"><ChevronRight size={14} className="rotate-180" /> Voltar</Link>
        {post.image_url && <img src={post.image_url.startsWith('/') ? `${BACKEND_URL}${post.image_url}` : post.image_url} alt={post.title} className="w-full aspect-video object-cover rounded-2xl mb-8" />}
        <h1 className="font-heading text-5xl text-[#0A2463] uppercase mb-6">{post.title}</h1>
        <div className="text-[#475569] leading-relaxed font-body">{post.content.split('\n').map((p, i) => <p key={i} className="mb-4">{p}</p>)}</div>
      </article>
    </div>
  );
};
